import React from 'react';
import { useOutletContext, Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getEvents } from '../services/api';
import EventCard from '../components/player/EventCard';
import LoadingSpinner from '../components/shared/LoadingSpinner';

const ClubLandingPage = () => {
    const { club } = useOutletContext();

    // Fetch filtered events for this club
    const { data: eventsData, isLoading } = useQuery({
        queryKey: ['events', { clubId: club.id }],
        queryFn: () => getEvents({ clubId: club.id }),
    });

    const events = eventsData?.events || [];

    return (
        <div>
            {/* Hero Section with Banner */}
            <div
                className="h-64 md:h-80 bg-cover bg-center relative"
                style={{
                    backgroundImage: club.bannerUrl ? `url(${club.bannerUrl})` : 'url(/padel_wide.png)',
                    backgroundColor: club.primaryColor || '#1f2937' // Fallback color
                }}
            >
                <div className="absolute inset-0 bg-black/40 backdrop-blur-[2px]"></div>
                <div className="absolute bottom-0 left-0 w-full p-6 md:p-10 text-white z-10 bg-gradient-to-t from-black/80 to-transparent">
                    <div className="container mx-auto">
                        <div className="flex items-end gap-6">
                            {/* Logo on Hero Mobile/Desktop */}
                            <div className="hidden md:block h-24 w-24 bg-white p-2 rounded-xl shadow-lg">
                                {club.logoUrl ? (
                                    <img src={club.logoUrl} alt="Logo" className="w-full h-full object-contain" />
                                ) : (
                                    <span className="w-full h-full flex items-center justify-center text-3xl font-bold text-gray-400">
                                        {club.name.charAt(0)}
                                    </span>
                                )}
                            </div>
                            <div>
                                <h1 className="text-3xl md:text-5xl font-black mb-2 shadow-sm text-shadow">
                                    {club.name}
                                </h1>
                                <p className="text-gray-200 text-lg flex items-center gap-2">
                                    <span>📍</span> {club.city}, {club.address || 'Ubicación'}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Content Container */}
            <div className="container mx-auto px-4 py-8">

                {/* Intro/Welcome (Optional) */}
                <div className="mb-10 max-w-3xl">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">Bienvenido a nuestro espacio</h2>
                    <p className="text-gray-600">
                        Aquí encontrarás todos los pozos y eventos organizados por {club.name}.
                        ¡Inscríbete y juega con nosotros!
                    </p>
                </div>

                {/* Events Grid */}
                <h3 className="text-xl font-black uppercase tracking-wide text-gray-400 mb-6 flex items-center gap-2">
                    <span className="w-2 h-8 bg-primary-500 rounded-full"></span>
                    Próximos Eventos
                </h3>

                {isLoading ? (
                    <div className="py-12 flex justify-center">
                        <LoadingSpinner />
                    </div>
                ) : events.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {events.map(event => (
                            <EventCard key={event.id} event={event} />
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-16 bg-white rounded-2xl shadow-sm border border-gray-100">
                        <div className="text-5xl mb-4">🎾</div>
                        <h3 className="text-xl font-bold text-gray-900 mb-2">No hay eventos activos</h3>
                        <p className="text-gray-500">
                            {club.name} no tiene eventos programados en este momento.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ClubLandingPage;
